export const classesConstants = {
  GET_ETUDIANTS: "GET_ETUDIANTS",
};
